import { render, staticRenderFns } from "./SearchSuggestions.vue?vue&type=template&id=89a1a3d2"
import script from "./SearchSuggestions.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchSuggestions.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SearchSuggestions.vue?vue&type=style&index=0&id=89a1a3d2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports